export enum EMaoMaintenanceName {
  'SCHEDULED MX' = 'SCHEDULED MX',
  'Service Checks' = 'Service Checks',
  'AOG OTHER' = 'AOG OTHER',
  'MEL Repair' = 'MEL Repair',
  'Aircraft Cleaning/Detail' = 'Aircraft Cleaning/Detail',
  'Service Check' = 'Service Check',
  'AOG MX' = 'AOG MX',
  'AOG FM' = 'AOG FM',
}
